<div class="realsize-image-modal">
    <div class="modal-dialog realsize-image-modal-dialog" style="width: 1000px !important;">
        <div class="container modal-content">
          <div class="modal-header">
            <div id='controls'>
              <button id='rotate_left' style="color: #D38029" type='button' title='Rotate left'> <i class="fas fa-undo"></i> </button>
              <button id='zoom_out'   style="color: #D38029"  type='button' title='Zoom out'> <i class="fas fa-search-minus"></i> </button>
              <button id='zoom_in'     style="color: #D38029" type='button' title='Zoom in'> <i class="fas fa-search-plus"></i> </button>
              <button id='rotate_right' style="color: #D38029" type='button' title='Rotate right'> <i class="fas fa-undo" style="transform: scaleX(-1);"></i> </button>
            </div>
            <button type="button" class="close" data-dismiss="modal" (click)="closeModal()">
              <i class="chevron-icon fas fa-times"></i>
            </button>
          </div>
          <i *ngIf="index+1 <= images.length && index > 0 "
             class="chevron-icon fas fa-chevron-circle-left text-left pt-1 pb-1"
             (click)="scroll('left')"></i>
          <i *ngIf="index+1 < images.length"
             class="chevron-icon fas fa-chevron-circle-right text-right pt-1 pb-1"
             (click)="scroll('right')"></i>
          <div class="frame modal-body">

            <img *ngIf="extensions[index] != 'pdf'" class="image" id='sample_picture'
                 [src]="'data:image/jpg;base64,'+images[index]"/>
            <p *ngIf="extensions[index] === 'pdf'">le type de fichier est PDF veuillez<br>
              le télécharger pour le visualiser</p>

          </div>
          <!--<div class='frame'>
            <img id='sample_picture' src='https://static.remove.bg/remove-bg-web/2a274ebbb5879d870a69caae33d94388a88e0e35/assets/start_remove-79a4598a05a77ca999df1dcb434160994b6fde2c3e9101984fb1be0f16d0a74e.png'>
          </div>-->
        </div>
    </div>
</div>
